import { Eye, EyeOff } from 'lucide-react'
import * as React from 'react'
import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

export const PasswordInput = ({
  ...props
}: React.ComponentProps<typeof Input>) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <div className="w-full relative">
      <Input
        {...props}
        type={isPasswordVisible ? 'text' : 'password'}
        className={cn('pr-8', props.className)}
      />
      <button
        type="button"
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-sm"
        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
        aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
        aria-pressed={isPasswordVisible}
      >
        {isPasswordVisible ? (
          <EyeOff className="size-4" aria-hidden="true" />
        ) : (
          <Eye className="size-4" aria-hidden="true" />
        )}
      </button>
    </div>
  )
}
